import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAuthHashRedirect, readAuthHash } from '../lib/authHashRedirect';

/**
 * Rattrape les liens d'e-mail Supabase qui atterrissent sur la racine du site
 * (redirectTo hors liste blanche → Site URL) et les renvoient vers la page qui
 * sait les traiter. Le fragment reste en mémoire (readAuthHash), il n'est pas
 * remis dans l'URL. Voir lib/authHashRedirect.js. Rend rien. Vit dans le Router.
 */
const AuthHashRedirect = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const target = getAuthHashRedirect(pathname, readAuthHash());
    if (target) navigate(target, { replace: true });
  }, [pathname, navigate]);

  return null;
};

export default AuthHashRedirect;
